import React from "react";
import { useState } from "react";
import { Link } from "react-scroll";
import menuClose from "../../Assets/close.png";
import hamBurgerMenu from "../../Assets/hamburger.png";

const Navbar = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const navLink = (
    <>
      <Link
        to="home"
        className="cursor-pointer hover:text-blue transition-all duration-300 ease"
        smooth={true}
        offset={-200}
      >
        Home
      </Link>
      <Link
        to="about"
        className="cursor-pointer hover:text-blue transition-all duration-300 ease"
        smooth={true}
        offset={-75}
      >
        About
      </Link>
      <Link
        to="myExperience"
        className="cursor-pointer hover:text-blue transition-all duration-300 ease"
        smooth={true}
        offset={0}
      >
        Experience
      </Link>
      <Link
        to="myProjects"
        className="cursor-pointer hover:text-blue transition-all duration-300 ease"
        smooth={true}
        offset={40}
      >
        Projects
      </Link>
      <Link
        to="contact"
        className="cursor-pointer hover:text-blue transition-all duration-300 ease"
        smooth={true}
        offset={80}
      >
        Contact
      </Link>
      <a
        href="https://drive.google.com/file/d/1NDfLgDHT6RJ0SHvu5EZmonxXsGYiu0tA/view?usp=drive_link"
        download={true}
        className="rounded px-2.5 py-1 overflow-hidden relative group cursor-pointer outline outline-blue text-blue hover:text-white"
        target="_blank"
        rel="noreferrer"
      >
        <span className="absolute w-64 h-0 transition-all duration-500 origin-center rotate-45 -translate-x-20 bg-blue top-1/2 group-hover:h-64 group-hover:-translate-y-32 ease"></span>
        <span className="relative transition duration-300 ease">Resume</span>
      </a>
    </>
  );

  return (
    <div className="lg:sticky md:sticky top-0 z-50">
      <div>
        <div className="lg:flex md:flex hidden justify-between px-24 py-6 bg-white shadow z-50 font-poppins">
          <div>
            <h1 className="text-lg font-semibold text-blue">khubaibul.dev</h1>
          </div>
          <div className="flex gap-x-5 items-center text-sm font-semibold">
            {navLink}
          </div>
        </div>
        <div className="lg:hidden md:hidden ml-4 mt-4">
          <button onClick={() => setMenuOpen(!menuOpen)}>
            <img src={hamBurgerMenu} className="w-7" alt="" />
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="lg:hidden md:hidden top-0 left-0 fixed h-full w-[70vw] transition-all ease-in-out duration-500 translate-y-0 z-10 p-4 backdrop-blur-[80px]  text-sm font-semibold font-poppins">
          <div className="flex justify-start mb-5 mr-2">
            <button onClick={() => setMenuOpen(!menuOpen)}>
              <img src={menuClose} className="w-7" alt="" />
            </button>
          </div>
          <div className="flex flex-col gap-y-5">{navLink}</div>
        </div>
      )}
    </div>
  );
};

export default Navbar;
